// Translation: Model > Phone number verifier > Phone verification dialog (English)
export default Object.freeze({
	actions: {
		cancel: 'Cancel',
		resend: 'Resend code',
		send: 'Send'
	},
	input: {
		placeholder: 'Enter code'
	},
	title: 'Verify your phone number'
})
